// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"307":"8de66dd4","312":"ac02f0aa","872":"1384cefe"}[chunkId] + ".js";
};